import CustomHTML from "components/CustomHTML"
import Pane from "components/Dashboards/General/Pane"
import { Image } from "react-bootstrap"
import { AssessmentViewOptionsType } from "shared/types/assessmentTypes"
import { SubmissionResponse, TopicQuestionResponse } from "shared/types/moduleTypes"
import { StudentSubmissionStatusType } from "shared/types/studentTypes"

interface Props {
    response: TopicQuestionResponse | SubmissionResponse
    index: number
    assessmentViewOption: AssessmentViewOptionsType
    submissionStatus: StudentSubmissionStatusType
}

const AssessmentResponseItem = ({ response, index, assessmentViewOption, submissionStatus } : Props) => {
    const correct: boolean = response.answer === response.correctAnswer
    const showCorrectness = !!((assessmentViewOption === "Correct/Incorrect" || assessmentViewOption === "Answers") && response.answer && submissionStatus !== "rework-required")
    const showCorrectAnswer = !!(assessmentViewOption === "Answers" && response.correctAnswer && !correct && response.answer && submissionStatus !== "rework-required")

    const questionImageExists = "assessmentQuestionImagePath" in response && !!response.assessmentQuestionImagePath
    const answerImageExists = "answerImagePath" in response && !!response.answerImagePath
    const correctAnswerImageExists = "correctAnswerImagePath" in response && !!response.correctAnswerImagePath

    return (<Pane className="mb-4 shadow-sm">
        <div className="text-start" key={index}>
            <span
                className={`pe-2 ${showCorrectness ? (correct ? `text-success` : `text-danger`) : `text-secondary`}`}>
                <span className="fw-bold">{response.questionNumber ?? (index + 1)}. </span> 
                <CustomHTML html={response.question} />
                {showCorrectness && <i className={`fas ${correct ? `fa-check text-success` : `fa-times text-danger`} ms-2`} />}
            </span>
            {questionImageExists && <div className="rounded my-2"><Image src={response.assessmentQuestionImagePath} alt="Assessment Question Image" fluid /></div>}
            <br /><br />
            {response.answer &&
                <div className="mb-2">
                    <strong>Your Answer: </strong><CustomHTML html={response.answer} />
                    {response.studentAnswerExplanation && <div className="mb-2"><strong>Explanation: </strong><CustomHTML html={response.studentAnswerExplanation} /></div>}
                <br />
                    {answerImageExists && <Image className="d-block" src={response.answerImagePath} alt="Answer Image" fluid />}
                </div>}
            {/* Only show the correct answer if correct answer for the question exists AND teacher allows student to view correct answer */}
            {(showCorrectAnswer && <>
                <div className="mb-2"><strong>Correct Answer: </strong><CustomHTML html={response.correctAnswer} /></div>
                {correctAnswerImageExists && <Image className="d-block" src={response.correctAnswerImagePath} alt="Correct Answer Image" fluid />}
                {response.correctAnswerExplanation && <div className="mb-2"><strong>Explanation: </strong><CustomHTML html={response.correctAnswerExplanation} /></div>}
            </>)}
        </div>
    </Pane>)
}

export default AssessmentResponseItem
